import { render, staticRenderFns } from "./gongyiForm.vue?vue&type=template&id=01e2a1f1&scoped=true&"
import script from "./gongyiForm.vue?vue&type=script&lang=js&"
export * from "./gongyiForm.vue?vue&type=script&lang=js&"
import style0 from "./gongyiForm.vue?vue&type=style&index=0&id=01e2a1f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e2a1f1",
  null
  
)

export default component.exports